module.exports = __webpack_public_path__ + "static/img/tri_l.ae7674f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/tri_l.png
// module id = 644
// module chunks = 2